import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View, type StyleType} from "@khanacademy/wonder-blocks-core";
import {color, sizing} from "@khanacademy/wonder-blocks-tokens";

interface CommonShimmerProps {
    animated?: boolean;
    style?: StyleType;
}

interface ShimmerRectangleProps extends CommonShimmerProps {
    width?: number | string;
    height?: number | string;
}

interface ShimmerCircleProps extends CommonShimmerProps {
    diameter?: number | string;
}

export const ShimmerRectangle = (
    props: ShimmerRectangleProps,
): React.ReactElement => {
    const {animated = true, style, width = "100%", height = 24} = props;
    const animationStyle = animated ? styles.shimmer : {};
    return (
        <View
            style={[
                styles.skeleton,
                styles.rectangle,
                {width, height},
                animationStyle,
                style,
            ]}
        />
    );
};

export const ShimmerCircle = (
    props: ShimmerCircleProps,
): React.ReactElement => {
    const {animated = true, style, diameter = 128} = props;
    const animationStyle = animated ? styles.shimmer : {};
    return (
        <View
            style={[
                styles.skeleton,
                styles.circle,
                {width: diameter, height: diameter},
                animationStyle,
                style,
            ]}
        />
    );
};

const keyframeAnimation = {
    "0%": {opacity: 0.4},
    "50%": {opacity: 1},
    "100%": {opacity: 0.4},
} as const;

const styles = StyleSheet.create({
    shimmer: {
        // @ts-expect-error - TS2322 - Type '{ readonly "0%": { readonly opacity: 0.4; }; readonly "50%": { readonly opacity: 1; }; readonly "100%": { readonly opacity: 0.4; }; }' is not assignable to type 'AnimationName | undefined'.
        animationName: keyframeAnimation,
        animationDuration: "2s",
        animationIterationCount: "infinite",
    },
    skeleton: {
        background: color.offBlack8,
    },
    circle: {
        borderRadius: "50%",
    },
    rectangle: {
        borderRadius: sizing.size_160,
    },
});
